import { render, staticRenderFns } from "./ActivePromosBtn.vue?vue&type=template&id=1b802740"
import script from "./ActivePromosBtn.vue?vue&type=script&lang=js"
export * from "./ActivePromosBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports